/* HumanFood bucket gift v2.0
   Auto-adds the recipe-matched bucket when a bag is in the cart.
   Rule: bag SKU -B- maps to pail SKU -P- (HF-CR1-B-11 -> HF-CR1-P-11).
   v2.0: variant map is hardcoded (Shopify drops custom-liquid sections
   from the footer group, so no Liquid context is available). Draft or
   unavailable pails fail the add gracefully and are skipped for the
   rest of the session, so this script is inert until pails go ACTIVE.
   Behaviors:
   - bag added -> matching bucket auto-added (tagged _hfc_gift), the
     BxGy discount strikes it to free
   - bag removed -> its auto-added gift bucket is removed too
   - deliberately purchased buckets (no tag) are never touched
   - never adds a duplicate bucket */
(() => {
  const MAP = {
    'HF-CR1-P-11': 48961868333307,
    'HF-CR1-P-22': 48961873838331,
    'HF-LR1-P-11': 48961873117435,
    'HF-LR1-P-22': 48961875378427,
    'HF-SR1-P-11': 48961869021435,
    'HF-SR1-P-22': 48961874133243
  };

  let busy = false;
  let timer = null;
  const disabledSkus = new Set();

  const bagToPail = (sku) => {
    if (!sku || sku.indexOf('-B-') === -1) return null;
    return sku.replace('-B-', '-P-');
  };

  const pailToBag = (sku) => {
    if (!sku || sku.indexOf('-P-') === -1) return null;
    return sku.replace('-P-', '-B-');
  };

  const getCart = () => {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  };

  const addPail = (sku, variantId) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _hfc_gift: 'yes' } }]
      })
    })
      .then((r) => {
        if (!r.ok) disabledSkus.add(sku);
        return r.ok;
      })
      .catch(() => {
        disabledSkus.add(sku);
        return false;
      });
  };

  const removeLine = (lineKey) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).catch(() => null);
  };

  const reconcile = async () => {
    if (busy) return;
    busy = true;

    try {
      const cart = await getCart();
      if (!cart || !cart.items) return;

      const bagSkus = new Set();
      const pailItems = [];

      cart.items.forEach((item) => {
        const sku = item.sku || '';
        if (sku.indexOf('-B-') !== -1) bagSkus.add(sku);
        if (MAP[sku] !== undefined) pailItems.push(item);
      });

      const neededPails = new Set();
      bagSkus.forEach((bagSku) => {
        const pailSku = bagToPail(bagSku);
        if (pailSku && MAP[pailSku] !== undefined && !disabledSkus.has(pailSku)) {
          neededPails.add(pailSku);
        }
      });

      const presentPailSkus = new Set(pailItems.map((i) => i.sku));

      let changed = false;

      for (const item of pailItems) {
        const isGift = item.properties && item.properties._hfc_gift === 'yes';
        const bagSku = pailToBag(item.sku);
        if (isGift && bagSku && !bagSkus.has(bagSku)) {
          await removeLine(item.key);
          changed = true;
        }
      }

      for (const pailSku of neededPails) {
        if (!presentPailSkus.has(pailSku)) {
          const ok = await addPail(pailSku, MAP[pailSku]);
          if (ok) changed = true;
        }
      }

      if (changed && window.location.pathname.indexOf('/cart') === 0) {
        window.location.reload();
      }
    } finally {
      busy = false;
    }
  };

  const schedule = () => {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(reconcile, 700);
  };

  const isCartMutation = (url) => {
    const u = String(url || '');
    return (
      u.indexOf('/cart/add') !== -1 ||
      u.indexOf('/cart/change') !== -1 ||
      u.indexOf('/cart/update') !== -1 ||
      u.indexOf('/cart/clear') !== -1
    );
  };

  const origFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0] && (arguments[0].url || arguments[0]);
    const result = origFetch.apply(this, arguments);
    if (isCartMutation(url)) {
      result.then(schedule).catch(() => {});
    }
    return result;
  };

  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) {
      this.addEventListener('loadend', schedule);
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
  window.addEventListener('pageshow', schedule);
})();
